// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".oselect-wrapper .label[data-v-1b36f4d7]{display:block;font-family:Open Sans,sans-serif;font-size:1.4rem;line-height:1.25;margin-bottom:.8rem}.oselect-wrapper .icon[data-v-1b36f4d7]{position:relative}.oselect-wrapper .error[data-v-1b36f4d7]{display:flex;align-items:center;--text-opacity:1;color:#ff4f4f;color:rgba(255,79,79,var(--text-opacity))}.oselect-wrapper .error svg[data-v-1b36f4d7]{display:flex;margin-right:.4rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
